export class ConsentProvider {

	static hasMarketingConsent() {
		return ConsentProvider.getCheckoutContext().marketingConsent === true;
	}

	static getCheckoutContext() {
		let state = { marketingConsent: null, statisticsConsent: null, consentSource: 'unavailable' };
		if (window.ideaConsent && typeof window.ideaConsent.getSnapshot === 'function') {
			state = window.ideaConsent.getSnapshot();
		}
		return state;
	}
}
